<template>
  <div class="invoicing">

    <TopTitle title="财务管理" />

    <div class="home-page-tab">
      <el-tabs v-model="tabIndex">
        <el-tab-pane label="开票记录" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 搜索 -->
    <div class="search-box">
      <el-form :inline="true">
        <el-form-item label="发票号码:">
          <el-input size="small" v-model="search.sn" placeholder="请输入" style="width: 220px;margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="开票时间:">
          <el-date-picker v-model="dateArr" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="empty">重置</el-button>
          <el-button type="primary" size="small" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-link class="export" icon="iconfont icon-daochujilu1" type="primary" @click="exporTables" :underline="false">导出表格</el-link>

    <div class="main-page">
      <div class="list-tab-page global-table ">
        <el-table ref="multipleTable" :data="tableData" :loading="loading" style="width: 100%">
          <el-table-column prop="sn" label="开票流水号" width="240"></el-table-column>
          <el-table-column prop="invoiceTitle" label="发票抬头">
            {{invoiceTitle}}
          </el-table-column>
          <el-table-column label="发票类型" width="100">
            <template slot-scope="scope">
              {{invoiceType[scope.row.invoiceType]}}
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="开票金额"></el-table-column>
          <el-table-column prop="gmtCreate" label="开票时间" min-width="160">
            <template slot-scope="scope">
              <span>
                {{moment(scope.row.gmtCreate).format("YYYY-MM-DD HH:mm:ss")}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <div class="invoice">
                <span :class="`bg-${scope.row.status}`">{{invoicingStatus[scope.row.status]}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="creatorAccount" label="开票人" width="180"></el-table-column>

          <el-table-column prop="name" label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-link class="operate-btn" icon="iconfont icon-xiangqing" type="primary" @click="details(scope.row)" :underline="false">详情</el-link>
              <el-link class="operate-btn btn-download" icon="iconfont icon-xiazai" type="primary" v-if="scope.row.status == 1" @click="getDownloadUrl(scope.row.invoiceUrl)" :underline="false">下载</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="global-page">
          <el-pagination background @size-change="changePageSize" @current-change="changePage" :page-sizes="[15, 30, 45, 60]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <InvoicDetail :visible="visible" :form="invoicingDetails" v-if="visible" @getDownloadUrl="getDownloadUrl">
      <div slot="status" :class="[
          'status-box',
          invoicingDetails.status == 2 ? 'status-box-one' : '',
        ]" v-if="invoicingDetails.status == 2">
        <span>状态：申请中</span>
      </div>
      <div slot="status" :class="[
          'status-box',
          invoicingDetails.status == 3 ? 'status-box-two' : '',
        ]" v-if="invoicingDetails.status == 3">
        <span>
          状态：开票失败
          <!-- <span style="margin-left: 20px">驳回理由：{{ invoicingDetails.remark }}</span> -->
        </span>
      </div>
      <div slot="status" :class="[
          'status-box',
          invoicingDetails.status == 1 ? 'status-box-three' : '',
        ]" v-if="invoicingDetails.status == 1">
        <span>状态：已开票</span>
      </div>
    </InvoicDetail>
  </div>
</template>

<script>
import moment from "moment"
import { httpAjax } from "@/api/ajax"
import { getDistanceMonth, urlEncode } from "@/utils/util"
import InvoicDetail from "./components/invoicDetail"
import TopTitle from '@/components/TopTitle'
import { MODE_CONF } from '@/utils/config'

const invoicingStatus = {
  0: "未开票",
  1: "已开票",
  2: "开票中",
  3: "开票失败",
  4: "无法开票",
}

const invoiceType = {
  1: "普通发票",
  2: "增值税专票",
}

export default {
  name: "invoicing",
  components: {
    InvoicDetail,
    TopTitle
  },
  data () {
    return {
      dateArr: '',
      tabIndex: '1',
      invoiceTitle: "",//发票抬头
      moment,
      invoiceType,
      invoicingStatus,
      search: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      total: 1,
      pageSize: 15,
      visible: false,
      invoicingDetails: {},
    }
  },
  watch: {
    dateArr (val) {
      this.search.startDate = val ? val[0] + ' 00:00:00' : ''
      this.search.endDate = val ? val[1] + ' 23:59:59' : ''
    }
  },
  mounted () {
    this.invoiceTitle = this.$store.getters.userData.companyName || "--"
    this.getData({
      currentPage: 1,
      pageSize: this.pageSize,
    })
  },
  methods: {
    // 清空
    empty () {
      this.search = {}
      this.dateArr = null
    },
    //导出
    exporTables () {
      if (this.dateArr) {
        let num = getDistanceMonth(this.search.startDate, this.search.endDate)
        if (num >= 3) {
          this.$message({
            message: '最多允许导出3个月的数据，请重新选择日期!',
            type: "error",
          })
        } else {
          let token = localStorage.getItem('userToken')
          let obg = {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            ...this.search
          }
          window.open(MODE_CONF.base_url + `/services/invoice/export?token=${token}${urlEncode(obg)}`)
        }
      } else {
        this.$message({
          message: '请选择交易时间',
          type: "error",
        })
      }
    },
    details (row) {
      this.invoicingDetails = row
      this.visible = true
    },
    searchData () {
      this.currentPage = 1
      this.getData()

    },
    //  获取数据
    getData () {
      this.loading = true
      httpAjax({
        url: "/services/invoice/query",
        method: "get",
        data: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          ...this.search
        },
      }).then((response) => {
        if (response.success) {
          this.tableData = response.data
          if (response.pager) {
            this.current = response.pager.currentPage
            this.total = Number(response.pager.total)
          }
        } else {
          this.$message({
            message: response.reasonPhrase,
            type: "error",
          })
        }
        this.loading = false
      })
    },
    // 获取发票下载链接
    getDownloadUrl (url) {
      if (url) {
        window.open(url)
        // let urlArr = url.split('&&')
        // for (let i = 0; i < urlArr.length; i++) {
        //   download(urlArr[i], `开票记录${i}.pdf`)
        // }
      } else {
        this.$message({
          message: "链接不存在",
          type: "error",
        })
      }
    },
    changePageSize (num) {
      this.pageSize = num
      this.currentPage = 1
      this.getData()
    },
    changePage (page) {
      this.currentPage = page
      this.getData()
    }
  },
}
</script>

<style scoped lang="less">
.invoicing {
  padding: 0 24px;
  background-color: white;
  height: 100%;
  .nav {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .home-page-tab {
    /deep/ .is-active {
      color: #106ae7 !important;
    }
    /deep/ .el-tabs__active-bar {
      background: #106ae7 !important;
    }
    /deep/ .el-tabs__item {
      font-size: 18px;
    }
    /deep/ .el-tabs__item:hover {
      font-size: 18px;
      color: #106ae7 !important;
    }
  }

  .search-box {
    min-height: 56px;
    background: #f7f7fa;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0 24px;

    .el-form-item {
      margin-bottom: 0;
    }
  }
  .btn-table {
    padding: 16px 0;
  }
  .status-box {
    padding: 8px 10px;
    border-radius: 4px;
  }
  .status-box-one {
    color: #faad14;
    background: #fffbe6;
  }
  .status-box-two {
    color: #ff4d4f;
    background: #fff1f0;
  }
  .status-box-three {
    background: rgba(0, 232, 118, 0.1);
    color: #22ac38;
  }
  .list-tab-page {
    background: white;
    .table-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 8px 0 8px 16px;
    }

    .btn-download:before {
      position: absolute;
      content: "";
      width: 1px;
      height: 14px;
      background: #05a4ea;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .invoice {
    span {
      position: relative;
      padding: 0 10px;
    }
    span:before {
      position: absolute;
      content: "";
      width: 6px;
      height: 6px;
      border-radius: 50px;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .bg-3:before {
      background: #e80000;
    }
    .bg-2:before {
      background: #fcbe02;
    }
    .bg-1:before {
      background: #0bb61c;
    }
  }
  /deep/.el-form .el-form-item .el-form-item__label {
    line-height: 32px !important;
  }
}
.global-page {
  padding-bottom: 24px;
}

.export {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  cursor: pointer;
  padding-bottom: 16px;
  margin-right: 24px;
  ::v-deep .iconfont {
    font-size: 12px;
    display: inline-block;
    padding-right: 4px !important;
  }
}

.operate-btn {
  // color: #1170eb;
  cursor: pointer;
  padding: 8px;
  position: relative;
  ::v-deep .iconfont {
    font-size: 12px;
    display: inline-block;
    padding-right: 4px !important;
  }
}
</style>